import React, { useEffect, useState } from "react";
import { API } from "../../../../../../config/api";
import swal from "sweetalert";
import ModalAddReusable from "../../../../../Global/ModalAddV1";
import LoaderHome from "../../../../../Loader/LoaderHome";

export default function SoapPasienAdd({ props, form, handleChange, handleSubmit, loading }) {
    const token = localStorage.getItem("token");
    const rolesData = JSON.parse(localStorage.getItem('roles')) || [];
    const idRole = rolesData[0]?.pivot?.id_role;

    const [getDataUser, setGetDataUser] = useState([]);

    const fetchParams = {
        headers: {
            "Authorization": `${token}`,
            "Content-Type": "application/json"
        }
    };

    const fetchUsers = async () => {
        try {
            const userRes = await API.get(`/user-service/users`, {
                ...fetchParams,
                params: {
                    page: 0,
                    limit: 90,
                    ascending: 1,
                    // id_role: idRole,
                    name_role: 'Doctor'
                }
            });

            if (userRes.status === 200 && userRes.data.data) {
                setGetDataUser(userRes.data.data);
            }
        } catch (error) {
            swal({
                title: 'Failed',
                text: error?.response?.data?.message || "Something went wrong",
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    if (loading) return <LoaderHome />;

    console.log(form)
    return (
        <ModalAddReusable
            isOpen={props.show}
            isClose={props.onHide}
            handleSubmit={handleSubmit}
            handleChange={handleChange}
            title="SOAP Pasien"
            fields={[
                { label: "Subjective (S)", name: "subjective", type: "textarea", value: form.subjective, microphone: true },
                { label: "Objective (O)", name: "objective", type: "textarea", value: form.objective, microphone: true },
                { label: "Assessment (A)", name: "assessment", type: "textarea", value: form.assessment, microphone: true },
                { label: "Planning (P)", name: "planning", type: "textarea", value: form.planning, microphone: true },
                { label: "Implementation (I)", name: "implementation", type: "textarea", value: form.implementation, microphone: true },
                { label: "Evaluation (E)", name: "evaluation", type: "textarea", value: form.evaluation, microphone: true },
                { label: "Note", name: "note", type: "textarea", value: form.note, microphone: true },
                {
                    label: "Dokter",
                    name: "create_by",
                    value: form.create_by,
                    type: "select",
                    options: getDataUser.map((item) => ({
                        value: item.id,
                        label: `${item.firstname} ${item.lastname}`,
                    })),
                    disabled: true
                }
            ]}
        />
    );
}
